require('@/prototypes/request');
require('@/prototypes/modal');
require('@/prototypes/modal-confirm');
